import { FOLLOW_SUGGESTION } from '../constants';
import { populateSuggestedMembers } from './suggestedMembers';
import parseActivityAndTrail from '../utils/track_trail_formatters';
import { getOptions, getFeed } from '../../../utils/requests/community_requests';

export const SET_FEED_OPTIONS = 'SET_FEED_OPTIONS';
export const UPDATE_ACTIVE_FEED = 'UPDATE_ACTIVE_FEED';

export const parseSuggestedMembersSection = sections => {
  return dispatch => {
    const follows = sections.find(s => s.section_type === FOLLOW_SUGGESTION);
    if (follows && follows.suggestions) {
      dispatch(populateSuggestedMembers(follows.suggestions));
    }
  };
};

export const getFeedOptions = () => {
  return (dispatch, getState) => {
    return getOptions(12345)
      .then(resp => {
        dispatch({ type: SET_FEED_OPTIONS, payload: resp.feeds });
      })
      .catch(err => {
        console.error('error loading feed options', err);
      });
  };
};

export const getActiveFeed = () => {
  return (dispatch, getState) => {
    const { activeFeedKey } = getState().feeds;
    return getFeed(12345, activeFeedKey)
      .then(resp => {
        dispatch(parseSuggestedMembersSection(resp.sections));
        dispatch({ type: UPDATE_ACTIVE_FEED, payload: parseActivityAndTrail(resp.sections) });
      })
      .catch(err => {
        console.error('error loading active feed', err);
      });
  };
};

export const initialCommunityFeedState = {
  activeFeedKey: null,
  feedOptions: [],
  feeds: []
};

export default function feeds(state = initialCommunityFeedState, action) {
  switch (action.type) {
    case SET_FEED_OPTIONS:
      return {
        ...state,
        feedOptions: action.payload,
        activeFeedKey: action.payload[0].name,
        feeds: action.payload.map(feed => {
          return { key: feed.name, activities: [] };
        })
      };
    case UPDATE_ACTIVE_FEED:
      return {
        ...state,
        feeds: state.feeds.map(feed => {
          if (state.activeFeedKey === feed.key) {
            return { ...feed, activities: [...feed.activities, ...action.payload] };
          }

          return feed;
        })
      };
    default:
      return state;
  }
}
